import { authApi } from 'api/AuthApi';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { selectAuthToken } from 'store/authSlice';
import { RootState } from 'store/store';

const UnauthorizedRoutes = () => {
  const token = useSelector(selectAuthToken);
  const meQueryState = useSelector((state: RootState) => authApi.endpoints.me.select()(state));
  const location = useLocation();

  const hasResolvedAuthUser = Boolean(meQueryState.data);
  const isMeQueryPending = meQueryState.isUninitialized || (meQueryState.isLoading && !hasResolvedAuthUser);

  if (token) {
    if (isMeQueryPending) {
      return null;
    }

    if (hasResolvedAuthUser) {
      return <Navigate to={location.state?.redirectUrl || '/'} />;
    }
  }

  return <Outlet />;
};

export default UnauthorizedRoutes;
